import { Controller } from "@hotwired/stimulus"

const euros = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", minimumFractionDigits: 0, maximumFractionDigits: 2 });

// Ventilation des gains de l'étape « Ventilation et reversements » : le reversement de cet étage, en %
// ou en euros, recalcule en direct ce qu'il reverse et ce qu'il garde sur chaque combinaison.
// Même règle que Version::Reversement#amount_cents : borné à ce que l'étage détient.
export default class extends Controller {
  static targets = ["rate", "kind", "toggle", "unit", "net", "reversed"];
  static values = { kind: String };

  toggle() {
    this.kindValue = this.kindValue === "amount" ? "percentage" : "amount";
    this.kindTarget.value = this.kindValue;
    const unit = this.kindValue === "amount" ? "€" : "%";
    this.toggleTarget.textContent = unit;
    this.unitTargets.forEach((el) => (el.textContent = unit));
    this.refresh();
  }

  refresh() {
    const value = parseFloat(this.rateTarget.value.replace(",", ".")) || 0;
    this.netTargets.forEach((net, i) => {
      const held = parseInt(net.dataset.held, 10);
      if (Number.isNaN(held)) return;
      const wanted = this.kindValue === "amount" ? Math.round(value * 100) : Math.round(held * value / 100);
      const reversed = Math.min(Math.max(wanted, 0), Math.max(held, 0));
      net.textContent = euros.format((held - reversed) / 100);
      net.classList.toggle("text-danger", held - reversed < 0);
      if (this.reversedTargets[i]) this.reversedTargets[i].textContent = euros.format(reversed / 100);
    });
  }
}
